import cookie from "js-cookie";

import supervisorCurrentsAndFeatures from "@/views/MasterClasses/Supervisor/TableCurrentsAndFeatures";
import supervisorFinished from "@/views/MasterClasses/Supervisor/TableFinished";
import mimkCurrentsAndFeatures from "@/views/MasterClasses/Mimk/TableCurrentsAndFeatures";
import mimkFinished from "@/views/MasterClasses/Mimk/TableFinished";
import mimkTimetable from "@/views/MasterClasses/Mimk/Timetable";
import mimkStatus from "@/views/MasterClasses/Supervisor/MimkStatus";
import supervisorMimktimetable from "@/views/MasterClasses/Supervisor/Timetable";
import managerMimktimetable from "@/views/MasterClasses/Manager/Timetable";
import managerTimetable from "@/views/MasterClasses/Manager/MyTimetable";
import ManagerNewMK from "@/views/MasterClasses/Manager/NewMK";
import ManagerMasterClasses from "@/views/MasterClasses/Manager/MasterClasses";
import ManagerHourConfirmation from "@/views/MasterClasses/Manager/HourConfirmation";
import statistic from "@/views/MasterClasses/Statistic";
import DetailMasterClass from "@/views/MasterClasses/DetailMasterClass";
import apiUser from "@/api/user";

let role = cookie.get("role");

async function redirect(next, pathType) {
  if (!role) {
    await apiUser.userInfo();
    role = cookie.get("role");
  }
  if (role !== "admin" && !pathType.includes(role)) {
    next("/error-page?code=403");
  } else {
    next();
  }
}

export default [
  {
    path: "/master-classes/",
    name: "MasterClasses",
    beforeEnter(to, from, next) {
      if (role === "manager" || role === "admin") {
        next("/master-classes/manager/new-mk/");
        return;
      } else {
        next(`/master-classes/${role}/current-and-features/`);
      }
    },
  },
  {
    path: "/timeslots-statistic",
    name: "statistic",
    component: statistic,
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | Statistics by Day",
    },
    beforeEnter(to, from, next) {
      to.params.fromPath = from.path;
      redirect(next, ["supervisor", "manager"]);
    },
  },

  {
    path: "/master-classes/manager/timetable/",
    name: "managerTimetable",
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | TCM Schedule",
    },
    component: managerMimktimetable,
    beforeEnter(to, from, next) {
      redirect(next, "manager");
    },
  },

  {
    path: "/master-classes/manager/my-timetable/",
    name: "mimkTimetable",
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | My Schedule",
    },
    component: managerTimetable,
    beforeEnter(to, from, next) {
      redirect(next, "manager");
    },
  },

  {
    path: "/master-classes/supervisor/current-and-features/",
    name: "supervisorCurrentsAndFeatures",
    meta: {
      role: {
        id: "supervisor",
        title: "role.supervisor",
      },
      tabTitle: "Booking | Current & Coming TCs",
    },
    component: supervisorCurrentsAndFeatures,
    beforeEnter(to, from, next) {
      redirect(next, "supervisor");
    },
  },
  {
    path: "/master-classes/supervisor/finished/",
    name: "supervisorFinished",
    meta: {
      role: {
        id: "supervisor",
        title: "role.supervisor",
      },
      tabTitle: "Booking | Completed TCs",
    },
    component: supervisorFinished,
    beforeEnter(to, from, next) {
      redirect(next, "supervisor");
    },
  },
  {
    path: "/master-classes/supervisor/status-mimk/",
    name: "StatusMimk",
    meta: {
      role: {
        id: "supervisor",
        title: "role.supervisor",
      },
      tabTitle: "Booking | TCM Status",
    },
    component: mimkStatus,
    beforeEnter(to, from, next) {
      redirect(next, "supervisor");
    },
  },
  {
    path: "/master-classes/supervisor/timetable/",
    name: "supervisorMimktimetable",
    meta: {
      role: {
        id: "supervisor",
        title: "role.supervisor",
      },
      tabTitle: "Booking | TCM Schedule",
    },
    component: supervisorMimktimetable,
    beforeEnter(to, from, next) {
      redirect(next, "supervisor");
    },
  },
  {
    path: "/master-classes/mimk/current-and-features/",
    name: "mimkCurrentsAndFeatures",
    meta: {
      role: {
        id: "mimk",
        title: "role.mimk",
      },
      tabTitle: "Booking | Current & Coming TCs",
    },
    component: mimkCurrentsAndFeatures,
    beforeEnter(to, from, next) {
      redirect(next, "mimk");
    },
  },
  {
    path: "/master-classes/mimk/finished/",
    name: "mimkFinished",
    meta: {
      role: {
        id: "mimk",
        title: "role.mimk",
      },
      tabTitle: "Booking | Completed TCs",
    },
    component: mimkFinished,
    beforeEnter(to, from, next) {
      redirect(next, "mimk");
    },
  },
  {
    path: "/master-classes/mimk/timetable/",
    name: "mimkTimetable",
    meta: {
      role: {
        id: "mimk",
        title: "role.mimk",
      },
      tabTitle: "Booking | My Schedule",
    },
    component: mimkTimetable,
    beforeEnter(to, from, next) {
      redirect(next, "mimk");
    },
  },
  {
    path: "/master-classes/manager/new-mk/",
    name: "ManagerNewMK",
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | New Record",
    },
    component: ManagerNewMK,
    beforeEnter(to, from, next) {
      redirect(next, "manager");
    },
  },
  {
    path: "/master-classes/manager/master-classes/",
    name: "ManagerMasterClasses",
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | All Trial-classes",
    },
    component: ManagerMasterClasses,
    beforeEnter(to, from, next) {
      redirect(next, "manager");
    },
  },
  {
    path: "/master-classes/manager/hour-confirmation/",
    name: "ManagerHourConfirmation",
    meta: {
      role: {
        id: "manager",
        title: "role.manager",
      },
      tabTitle: "Booking | Confirmation 2.0",
    },
    component: ManagerHourConfirmation,
    beforeEnter(to, from, next) {
      redirect(next, "manager");
    },
  },
  {
    path: "/master-classes/detail/:id",
    name: "DetailMasterClass",
    component: DetailMasterClass,
    meta: {
      role: {
        id: "supervisor",
        title: "role.supervisor",
      },
      tabTitle: "Booking | Record Details",
    },
  },
];
